<template>
  <div
    data-test-id="kitchen-card"
  >
    <q-card
      class="kitchen-card-item q-mx-xs"
    >
      <kitchen-order-slide-item
        :index="index"
        :kitchen-display="kitchenDisplay"
        :order="order"
        :delivery-type="deliveryType"
        :order-items="orderItems"
        :tab="tab"
        @refresh="value => $emit('refresh', value)"
        @select="selected = `_${order.id}_`"
        @deselect="selected = null"
      />
      <q-separator color="grey-7" />
    </q-card>

    <template
      v-for="({ orderItemsForStage, orderItemsByIdentifier }, stage) in orderItemsByStage"
    >
      <q-card
        v-if="stage !== 'Current'"
        :key="`stage_${order.id}_${deliveryType}_${stage}`"
        class="kitchen-card-item q-mx-xs"
        square
      >
        <kitchen-stage-expansion-item
          :model-value="expandedBy[`stage_${order.id}_${deliveryType}_${stage}`]"
          :index="index"
          :kitchen-display="kitchenDisplay"
          :order="order"
          :order-items="orderItemsForStage"
          :stage="stage"
          :tab="tab"
          @refresh="value => $emit('refresh', value)"
          @update:model-value="value => expand(`stage_${order.id}_${deliveryType}_${stage}`, value)"
          @select="selected = `_${order.id}_${deliveryType}_${stage}`"
          @deselect="selected = null"
        />
        <q-separator color="grey-7" />
      </q-card>
      <template v-if="expandedBy[`stage_${order.id}_${deliveryType}_${stage}`]">
        <template
          v-for="(orderItemsForIdentifier, identifier) in orderItemsByIdentifier"
          :key="`orderItemsForIdentifier_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`"
        >
          <q-card
            class="kitchen-card-item q-mx-xs"
            square
          >
            <kitchen-order-item-expansion-item
              v-if="orderItemsForIdentifier.length > 1"
              :model-value="expandedBy[`orderItemsForIdentifier_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`]"
              :index="index"
              :kitchen-display="kitchenDisplay"
              :order="order"
              :order-items="orderItemsForIdentifier"
              :tab="tab"
              :show-preparation-counter="kitchenDisplay.kitchenDisplayType.showPreparationCountdown"
              :selected="$_.includes(`_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`, selected)"
              @refresh="value => $emit('refresh', value)"
              @update:model-value="value => expand(`orderItemsForIdentifier_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`, value)"
              @select="selected = `_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`"
              @deselect="selected = null"
            />
            <kitchen-order-item-slide-item
              v-else
              :index="index"
              :kitchen-display="kitchenDisplay"
              :order="order"
              :order-items="orderItemsForIdentifier"
              :tab="tab"
              :show-preparation-counter="kitchenDisplay.kitchenDisplayType.showPreparationCountdown"
              :selected="$_.includes(`_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`, selected)"
              @refresh="value => $emit('refresh', value)"
              @select="selected = `_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`"
              @deselect="selected = null"
            />
            <q-separator color="grey-7" />
          </q-card>
          <template v-if="expandedBy[`orderItemsForIdentifier_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}`]">
            <template
              v-for="(orderItem, orderItemIndex) in orderItemsForIdentifier"
              :key="`orderItemsForIdentifier_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}_${orderItemIndex}`"
            >
              <q-card
                class="kitchen-card-item q-mx-xs"
                square
              >
                <kitchen-order-item-slide-item
                  :index="index"
                  :kitchen-display="kitchenDisplay"
                  :order="order"
                  :order-items="[orderItem]"
                  :tab="tab"
                  :indent="1"
                  :selected="$_.includes(`_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}_${orderItemIndex}`, selected)"
                  @refresh="value => $emit('refresh', value)"
                  @select="selected = `_${order.id}_${deliveryType}_${stage}_${dueTime}_${identifier}_${orderItemIndex}`"
                  @deselect="selected = null"
                />
                <q-separator color="grey-7" />
              </q-card>
            </template>
          </template>
        </template>
      </template>
    </template>
    <template
      v-if="!!orderItemsByStage.Current"
    >
      <template
        v-for="(orderItemsForIdentifier, identifier) in orderItemsByStage.Current.orderItemsByIdentifier"
        :key="`orderItemsForIdentifier_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`"
      >
        <q-card
          class="kitchen-card-item q-mx-xs"
          square
        >
          <kitchen-order-item-expansion-item
            v-if="orderItemsForIdentifier.length > 1"
            :model-value="expandedBy[`orderItemsForIdentifier_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`]"
            :index="index"
            :kitchen-display="kitchenDisplay"
            :order="order"
            :order-items="orderItemsForIdentifier"
            :tab="tab"
            :show-preparation-counter="kitchenDisplay.kitchenDisplayType.showPreparationCountdown"
            :selected="$_.includes(`_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`, selected)"
            @refresh="value => $emit('refresh', value)"
            @update:model-value="value => expand(`orderItemsForIdentifier_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`, value)"
            @select="selected = `_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`"
            @deselect="selected = null"
          />
          <kitchen-order-item-slide-item
            v-else
            :index="index"
            :kitchen-display="kitchenDisplay"
            :order="order"
            :order-items="orderItemsForIdentifier"
            :tab="tab"
            :show-preparation-counter="kitchenDisplay.kitchenDisplayType.showPreparationCountdown"
            :selected="$_.includes(`_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`, selected)"
            @refresh="value => $emit('refresh', value)"
            @select="selected = `_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`"
            @deselect="selected = null"
          />
          <q-separator color="grey-7" />
        </q-card>
        <template v-if="orderItemsForIdentifier.length > 1 && expandedBy[`orderItemsForIdentifier_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}`]">
          <template
            v-for="(orderItem, orderItemIndex) in orderItemsForIdentifier"
            :key="`orderItemsForIdentifier_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}_${orderItemIndex}`"
          >
            <q-card
              class="kitchen-card-item q-mx-xs"
              square
            >
              <kitchen-order-item-slide-item
                :index="index"
                :kitchen-display="kitchenDisplay"
                :order="order"
                :order-items="[orderItem]"
                :tab="tab"
                :indent="1"
                :selected="$_.includes(`_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}_${orderItemIndex}`, selected)"
                @refresh="value => $emit('refresh', value)"
                @select="selected = `_${order.id}_${deliveryType}_Current_${dueTime}_${identifier}_${orderItemIndex}`"
                @deselect="selected = null"
              />
              <q-separator color="grey-7" />
            </q-card>
          </template>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import KitchenOrderItemExpansionItem from 'src/modules/kds/components/kitchen-card/KitchenOrderItemExpansionItem'
import KitchenOrderItemSlideItem from 'src/modules/kds/components/kitchen-card/KitchenOrderItemSlideItem'
import KitchenOrderSlideItem from 'src/modules/kds/components/kitchen-card/KitchenOrderSlideItem'
import KitchenStageExpansionItem from 'src/modules/kds/components/kitchen-card/KitchenStageExpansionItem'

export default {
  name: 'KitchenCard',
  components: {
    KitchenOrderSlideItem,
    KitchenOrderItemExpansionItem,
    KitchenOrderItemSlideItem,
    KitchenStageExpansionItem
  },
  configuration: ['currentSite'],
  props: {
    index: {
      type: Number,
      required: false,
      default: 1
    },
    kitchenDisplay: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    },
    orderItems: {
      type: Array,
      required: true
    },
    orderItemsByStage: {
      type: Object,
      required: true
    },
    tab: {
      type: String,
      required: true
    },
    deliveryType: {
      type: String,
      required: true
    },
    dueTime: {
      type: String,
      required: true
    },
    zoom: {
      type: Number,
      required: false,
      default: 1
    }
  },
  emits: ['refresh'],
  data () {
    return {
      expandedBy: {},
      selected: null
    }
  },
  methods: {
    expand (key, value) {
      this.expandedBy[key] = value
    }
  }
}
</script>

<style scoped>
.kitchen-card-item {
  min-width: 420px;
  max-width: 520px;
}
</style>
